document.addEventListener('click', function(e) {
  let item = e.target.closest('.doubly-nice-select .option');
  if (item) {
    let currency = item.getAttribute('data-value');
    let currentPath = window.location.pathname + window.location.search;
    console.log(item);

    if (currency === 'AED') {
      window.location.href = 'https://gameon.store' + currentPath;
    } else if (currency === 'SAR') {
      window.location.href = 'https://sa.gameon.store' + currentPath;
    } else if (currency === 'KWD') {
      window.location.href = 'https://kw.gameon.store' + currentPath;
    } else {
      window.location.href = 'https://gameon.store' + currentPath;
    }
  }
});
